// Stub — huddles are not used in the Sales Platform
export function useHuddles() {
  return {
    huddles: [] as any[],
    activeHuddle: null as any,
    isLoading: false,
    // Stub methods used by DesktopNotificationProvider
    joinHuddle: async (_huddleId: string) => {},
    declineInvite: async (_huddleId: string) => {},
  };
}

export function useHuddleActions() {
  return {
    startHuddle: async () => {},
    joinHuddle: async () => {},
    leaveHuddle: async () => {},
    endHuddle: async () => {},
  };
}

export type { };
